<template>
  <v-container fluid>
    <PageHeading
      text="Заказы событий"
      mode="grid"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    />
    <v-row>
      <v-col>
        <GridOrdersEvent ref="grid"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GridOrdersEvent from './grid'
import PageHeading from '@/components/page-heading'
import gridPageInterface from '@/interfaces/grid-page-interface-mixin'

export default {
  components: {
    PageHeading,
    GridOrdersEvent
  },
  metaInfo () {
    return {
      title: 'Заказы событий'
    }
  },
  mixins: [gridPageInterface]
}
</script>
